(function () {
  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = String(format || '${{amount}}').replace(/<[^>]*>/g, '');

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var value = (number / 100).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var remainder = parts[1] ? decimal + parts[1] : '';
      return dollars + remainder;
    }

    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    var value = formatWithDelimiters(cents, 2);

    if (placeholder === 'amount_no_decimals') {
      value = formatWithDelimiters(cents, 0);
    } else if (placeholder === 'amount_with_comma_separator') {
      value = formatWithDelimiters(cents, 2, '.', ',');
    } else if (placeholder === 'amount_no_decimals_with_comma_separator') {
      value = formatWithDelimiters(cents, 0, '.', ',');
    }

    return formatString.replace(placeholderRegex, value);
  }

  function fillTemplate(template, count, percent) {
    return String(template || '')
      .replace(/\{count\}/g, String(count))
      .replace(/\{percent\}/g, String(percent));
  }

  function selectedChecks(slide) {
    return Array.prototype.slice.call(slide.querySelectorAll('[data-stl-check]')).filter(function (input) {
      return input.checked && !input.disabled;
    });
  }

  function discountForCount(slide, count) {
    var tiers = [];
    try {
      tiers = JSON.parse(slide.getAttribute('data-discount-tiers') || '[]');
    } catch (e) {
      tiers = [];
    }
    if (!Array.isArray(tiers) || !tiers.length || count <= 0) return 0;

    var bestItems = -1;
    var percent = 0;
    tiers.forEach(function (tier) {
      var items = Number(tier && tier.items) || 0;
      var value = Number(tier && tier.percent) || 0;
      if (items > 0 && count >= items && items >= bestItems) {
        bestItems = items;
        percent = value;
      }
    });
    return percent;
  }

  function setText(slide, selector, text) {
    var el = slide.querySelector(selector);
    if (el) el.textContent = text;
  }

  function update(root, slide) {
    var checks = Array.prototype.slice.call(slide.querySelectorAll('[data-stl-check]'));
    var selected = selectedChecks(slide);
    var count = selected.length;
    var percent = discountForCount(slide, count);
    var moneyFormat = root.dataset.moneyFormat;

    var subtotal = selected.reduce(function (sum, input) {
      return sum + (Number(input.dataset.price) || 0);
    }, 0);
    var saving = Math.round((subtotal * percent) / 100);
    var total = Math.max(subtotal - saving, 0);

    checks.forEach(function (input) {
      var row = input.parentElement;
      if (row) row.classList.toggle('is-selected', input.checked && !input.disabled);

      var hotspot = slide.querySelector('[data-stl-hotspot="' + input.dataset.stlIndex + '"]');
      if (hotspot) {
        hotspot.classList.toggle('is-active', input.checked && !input.disabled);
        hotspot.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      }
    });

    setText(slide, '[data-stl-count]', String(count));
    setText(slide, '[data-stl-subtotal]', formatMoney(subtotal, moneyFormat));
    setText(slide, '[data-stl-saving]', saving ? '−' + formatMoney(saving, moneyFormat) : formatMoney(0, moneyFormat));
    setText(slide, '[data-stl-saving-label]', fillTemplate(root.dataset.labelSaving, count, percent));
    setText(slide, '[data-stl-total]', formatMoney(total, moneyFormat));

    var savingRow = slide.querySelector('[data-stl-saving-row]');
    if (savingRow) savingRow.hidden = percent <= 0;

    var badge = slide.querySelector('[data-stl-badge]');
    if (badge) {
      if (percent > 0 && count > 0) {
        badge.hidden = false;
        badge.textContent = fillTemplate(root.dataset.savingBadge, count, percent);
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    }

    var button = slide.querySelector('[data-stl-add]');
    if (button) {
      var template = root.dataset.addLabelPlural;
      if (count === 0) {
        template = root.dataset.addLabelEmpty;
      } else if (count === 1) {
        template = root.dataset.addLabel;
      }
      button.textContent = fillTemplate(template, count, percent);
      button.disabled = count === 0;
    }
  }

  function replaceSection(selector, html) {
    if (!html) return;
    var current = document.querySelector(selector);
    if (!current) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector(selector);
    if (next) current.outerHTML = next.outerHTML;
  }

  function addToCart(root, slide) {
    var button = slide.querySelector('[data-stl-add]');
    var errorEl = slide.querySelector('[data-stl-error]');
    var selected = selectedChecks(slide);
    if (!selected.length) return;

    if (errorEl) errorEl.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    var payload = {
      items: selected.map(function (input) {
        return { id: Number(input.value), quantity: 1 };
      }),
      sections: document.querySelector('cart-drawer') ? ['cart-icon-bubble', 'cart-drawer'] : ['cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Could not add items to cart');
          }
          return data;
        });
      })
      .then(function (data) {
        if (data.sections) {
          replaceSection('#cart-icon-bubble', data.sections['cart-icon-bubble']);
          replaceSection('cart-drawer', data.sections['cart-drawer']);
        }

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'mt-womo-shop-the-look', cartData: data });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function (error) {
        if (errorEl) {
          errorEl.textContent = error.message || 'Could not add items to cart';
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        update(root, slide);
      });
  }

  function goTo(root, index) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-stl-slide]'));
    if (!slides.length) return;

    var next = ((index % slides.length) + slides.length) % slides.length;
    root.dataset.stlCurrent = String(next);

    slides.forEach(function (slide, i) {
      slide.hidden = i !== next;
    });

    root.querySelectorAll('[data-stl-dot]').forEach(function (dot) {
      var isCurrent = Number(dot.getAttribute('data-stl-dot')) === next;
      dot.setAttribute('aria-current', isCurrent ? 'true' : 'false');
    });
  }

  function currentSlide(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-stl-slide]'));
    return slides[Number(root.dataset.stlCurrent) || 0] || slides[0];
  }

  function init(root) {
    if (root.dataset.stlReady === 'true') return;
    root.dataset.stlReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-stl-slide]'));
    if (!slides.length) return;

    root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-stl-check]');
      if (!input) return;
      var slide = input.closest('[data-stl-slide]');
      if (slide) update(root, slide);
    });

    root.addEventListener('click', function (event) {
      var hotspot = event.target.closest('[data-stl-hotspot]');
      if (hotspot) {
        var slide = hotspot.closest('[data-stl-slide]');
        var input = slide.querySelector(
          '[data-stl-check][data-stl-index="' + hotspot.getAttribute('data-stl-hotspot') + '"]'
        );
        if (input && !input.disabled) {
          input.checked = !input.checked;
          update(root, slide);
        }
        return;
      }

      var prev = event.target.closest('[data-stl-prev]');
      if (prev) {
        goTo(root, (Number(root.dataset.stlCurrent) || 0) - 1);
        return;
      }

      var next = event.target.closest('[data-stl-next]');
      if (next) {
        goTo(root, (Number(root.dataset.stlCurrent) || 0) + 1);
        return;
      }

      var dot = event.target.closest('[data-stl-dot]');
      if (dot) {
        goTo(root, Number(dot.getAttribute('data-stl-dot')));
        return;
      }

      var add = event.target.closest('[data-stl-add]');
      if (add) {
        var addSlide = add.closest('[data-stl-slide]');
        if (addSlide) addToCart(root, addSlide);
      }
    });

    goTo(root, Number(root.dataset.stlCurrent) || 0);
    slides.forEach(function (slide) {
      update(root, slide);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.mt-womo-stl').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('.mt-womo-stl');
    if (!root) return;
    var slide = event.target.closest('[data-stl-slide]') || event.target;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-stl-slide]'));
    var index = slides.indexOf(slide);
    if (index >= 0) goTo(root, index);
  });
})();
